import RowCommonDocs from './RowCommonDocs';

export default RowCommonDocs;
